export default {
  WAIT: 'WAIT',
  START: 'START',
  PLAYING: 'PLAYING',
  END: 'END'
}



// WEBPACK FOOTER //
// ./src/common/game_state.js